import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addClassification, getClassification, updateClassification } from "./ClassificationRepository";


export const useClassificationListData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["CLASSIFICATION", params],
        queryFn: () => getClassification(params),
        enabled: enable,
        retry: false,
    });
};

export const useAddClassification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addClassification,
        onSuccess: (data) => {
            toast.success("Classification Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["CLASSIFICATION"] });
            // <Loader />
        },
        onError: (error) => {
            toast.error("Failed to Add Classification!");
        },
    });
};
export const useUpdateClassification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({  body }: {  body: any }) =>
            updateClassification(body),
        onSuccess: (data) => {
            toast.success("Update Classication Successfully!");
            queryClient.invalidateQueries({ queryKey: ["CLASSIFICATION"] });
        },
        onError: (error) => {
            toast.error("Failed to Update Classification!");
        },
    });
};

